import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {

        const maxDots = 3;
        let cycleIndex = 0;
        let lastSlide = 0;

        $(this.element).on('init', function (event, slick) {
            const $dots = slick.$dots?.find('li');
            if ($dots?.length > maxDots) {
                $dots.slice(maxDots).remove();
            }
        });

        $(this.element).on('afterChange', function (event, slick, currentSlide) {

            if (currentSlide === lastSlide) {
                return;
            }

            const $dots = slick.$dots.find('li');

            if (currentSlide > lastSlide) {
                cycleIndex = (cycleIndex + 1) % 3;
            } else {
                cycleIndex = (cycleIndex - 1 + 3) % 3;
            }

            $dots.removeClass('slick-active');
            $dots.eq(cycleIndex).addClass('slick-active');

            lastSlide = currentSlide;
        });

        $(this.element).slick({
            variableWidth: true, 
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            infinite: false,
            autoplay: false,

            prevArrow: "<span class='slick-prev pull-left'><i class='fal fa-chevron-left'></i></span>",
            nextArrow: "<span class='slick-next pull-right'><i class='fal fa-chevron-right'></i></span>",

            customPaging: function (slider, i) {
                if (i < maxDots) {
                    return '<button type="button" class="custom-dot"></button>';
                }
                return '';
            },
            responsive: [
                { breakpoint: 1350, settings: { variableWidth: false, slidesToShow: 2 } },
                { breakpoint: 1024, settings: { variableWidth: false, slidesToShow: 2 } },
                { breakpoint: 768, settings: { variableWidth: false,  slidesToShow: 1 } }
            ]
        });
    }

    disconnect() {
        if ($(this.element).hasClass('slick-initialized')) {
            $(this.element).slick('unslick');
        }
    }
}
